import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAuth } from "~/lib/server-auth";

/**
 * Authenticated layout route
 *
 * All routes under this layout require authentication.
 * The beforeLoad hook runs on both SSR and client-side navigation.
 *
 * IMPORTANT: Do NOT wrap requireAuth in Effect - TanStack redirects must be
 * thrown directly, not wrapped in Effect which turns them into FiberFailures.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/flirtmachine/_authenticated")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
    const auth = await requireAuth();
    return { auth };
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return <Outlet />;
}
